export interface ChildProfile {
  id: string;
  caseNumber: string;
  firstName: string;
  lastName: string;
  middleName: string;
  nickname: string;
  birthDate: string;
  age: number;
  gender: string;
  civilStatus: string;
  nationality: string;
  religion: string;
  address: string;
  barangay: string;
  municipality: string;
  province: string;
  schoolName: string;
  gradeLevel: string;
  guardianName: string;
  guardianRelationship: string;
  guardianContact: string;
  guardianAddress: string;
  fatherName: string;
  motherName: string;
  siblings: number;
  birthOrder: number;
  medicalConditions: string;
  medications: string;
  riskScore: number;
  riskLevel: 'low' | 'moderate' | 'high' | 'critical';
  status: 'active' | 'closed' | 'archived' | 'referred';
  assignedWorker: string;
  photo: string;
  createdAt: string;
  incidentType: string;
  incidentDate: string;
  incidentDescription: string;
  documents: { name: string; type: string; date: string; size: string }[];
  timeline: { date: string; action: string; user: string; notes: string }[];
  referrals: { agency: string; date: string; purpose: string; status: string }[];
  interAgencyNotes: { agency: string; note: string; date: string; officer: string }[];
}

export const mockChildren: ChildProfile[] = [
  {
    id: 'ch1',
    caseNumber: 'DCPCMS-2026-00001',
    firstName: 'Juan',
    lastName: 'Dela Cruz',
    middleName: 'Santos',
    nickname: 'Juanito',
    birthDate: '2018-03-12',
    age: 8,
    gender: 'Male',
    civilStatus: 'Single',
    nationality: 'Filipino',
    religion: 'Roman Catholic',
    address: '123 Mabini St.',
    barangay: 'Brgy. San Jose',
    municipality: 'Batangas City',
    province: 'Batangas',
    schoolName: 'San Jose Elementary School',
    gradeLevel: 'Grade 2',
    guardianName: 'Rosa Dela Cruz',
    guardianRelationship: 'Mother',
    guardianContact: '09171234567',
    guardianAddress: '123 Mabini St., Brgy. San Jose, Batangas City',
    fatherName: 'Roberto Dela Cruz',
    motherName: 'Rosa Santos Dela Cruz',
    siblings: 2,
    birthOrder: 1,
    medicalConditions: 'None',
    medications: 'None',
    riskScore: 87,
    riskLevel: 'critical',
    status: 'active',
    assignedWorker: 'Maria Santos',
    photo: 'https://readdy.ai/api/search-image?query=young%20Filipino%20boy%208%20years%20old%20school%20uniform%20portrait%20simple%20white%20background%20professional%20photo&width=200&height=200&seq=ch1&orientation=squarish',
    createdAt: '2026-01-15',
    incidentType: 'Physical Abuse',
    incidentDate: '2026-01-14',
    incidentDescription: 'Child was brought to the barangay health center with multiple bruises on arms and back. Neighbor reported hearing screaming from the household.',
    documents: [
      { name: 'Medical Certificate', type: 'PDF', date: '2026-01-15', size: '245 KB' },
      { name: 'Incident Report', type: 'PDF', date: '2026-01-15', size: '180 KB' },
      { name: 'Barangay Blotter', type: 'PDF', date: '2026-01-14', size: '120 KB' },
      { name: 'Photo Evidence', type: 'JPG', date: '2026-01-15', size: '2.1 MB' },
    ],
    timeline: [
      { date: '2026-04-09', action: 'Risk assessment updated to Critical', user: 'Maria Santos', notes: 'Follow-up home visit conducted. Situation remains concerning.' },
      { date: '2026-03-20', action: 'Home visit conducted', user: 'Maria Santos', notes: 'Child appears stable. Guardian counseled.' },
      { date: '2026-02-10', action: 'Case conference held', user: 'Jose Reyes', notes: 'Supervisor reviewed case. Intervention plan approved.' },
      { date: '2026-01-20', action: 'Initial assessment completed', user: 'Maria Santos', notes: 'Child placed under protective custody temporarily.' },
      { date: '2026-01-15', action: 'Case opened', user: 'Maria Santos', notes: 'Case intake form completed. Case number assigned.' },
    ],
    referrals: [
      { agency: 'Batangas City Health Office', date: '2026-01-16', purpose: 'Medical evaluation and treatment', status: 'Completed' },
      { agency: 'Department of Justice', date: '2026-02-01', purpose: 'Legal assistance for filing charges', status: 'Ongoing' },
    ],
    interAgencyNotes: [
      { agency: 'PNP Women & Children Protection Desk', note: 'Perpetrator identified and under investigation. Case filed.', date: '2026-01-20', officer: 'SPO1 Reyes' },
      { agency: 'Batangas City Health Office', note: 'Child cleared medically. Psychological evaluation recommended.', date: '2026-01-18', officer: 'Dr. Lim' },
    ],
  },
  {
    id: 'ch2',
    caseNumber: 'DCPCMS-2026-00002',
    firstName: 'Ana',
    lastName: 'Reyes',
    middleName: 'Garcia',
    nickname: 'Anita',
    birthDate: '2014-07-22',
    age: 12,
    gender: 'Female',
    civilStatus: 'Single',
    nationality: 'Filipino',
    religion: 'Roman Catholic',
    address: '45 Rizal Ave.',
    barangay: 'Brgy. Poblacion',
    municipality: 'Lipa City',
    province: 'Batangas',
    schoolName: 'Lipa City National High School',
    gradeLevel: 'Grade 6',
    guardianName: 'Carla Reyes',
    guardianRelationship: 'Aunt',
    guardianContact: '09281234567',
    guardianAddress: '45 Rizal Ave., Brgy. Poblacion, Lipa City',
    fatherName: 'Unknown',
    motherName: 'Deceased',
    siblings: 0,
    birthOrder: 1,
    medicalConditions: 'Malnutrition (mild)',
    medications: 'Vitamins',
    riskScore: 72,
    riskLevel: 'high',
    status: 'active',
    assignedWorker: 'Maria Santos',
    photo: 'https://readdy.ai/api/search-image?query=young%20Filipino%20girl%2012%20years%20old%20school%20uniform%20portrait%20simple%20white%20background%20professional%20photo&width=200&height=200&seq=ch2&orientation=squarish',
    createdAt: '2026-02-03',
    incidentType: 'Neglect',
    incidentDate: '2026-02-01',
    incidentDescription: 'Child reported to school guidance counselor as frequently absent, malnourished, and wearing dirty clothes. Home visit revealed inadequate living conditions.',
    documents: [
      { name: 'School Report', type: 'PDF', date: '2026-02-03', size: '156 KB' },
      { name: 'Nutritional Assessment', type: 'PDF', date: '2026-02-05', size: '200 KB' },
    ],
    timeline: [
      { date: '2026-04-07', action: 'Submitted for supervisor review', user: 'Maria Santos', notes: 'Awaiting approval for intervention plan.' },
      { date: '2026-03-15', action: 'Follow-up visit', user: 'Maria Santos', notes: 'Slight improvement in living conditions.' },
      { date: '2026-02-10', action: 'Nutritional support provided', user: 'Maria Santos', notes: 'Coordinated with LGU for food assistance.' },
      { date: '2026-02-03', action: 'Case opened', user: 'Maria Santos', notes: 'Initial intake completed.' },
    ],
    referrals: [
      { agency: 'Lipa City Health Office', date: '2026-02-05', purpose: 'Nutritional assessment and supplementation', status: 'Ongoing' },
    ],
    interAgencyNotes: [
      { agency: 'DepEd Lipa City', note: 'School will provide feeding program and school supplies.', date: '2026-02-08', officer: 'Principal Gomez' },
    ],
  },
  {
    id: 'ch3',
    caseNumber: 'DCPCMS-2026-00003',
    firstName: 'Pedro',
    lastName: 'Villanueva',
    middleName: 'Ramos',
    nickname: 'Pedring',
    birthDate: '2020-05-18',
    age: 6,
    gender: 'Male',
    civilStatus: 'Single',
    nationality: 'Filipino',
    religion: 'Roman Catholic',
    address: '78 Bonifacio St.',
    barangay: 'Brgy. Kumintang Ibaba',
    municipality: 'Batangas City',
    province: 'Batangas',
    schoolName: 'Not enrolled',
    gradeLevel: 'N/A',
    guardianName: 'Ernesto Villanueva',
    guardianRelationship: 'Father',
    guardianContact: '09351234567',
    guardianAddress: '78 Bonifacio St., Brgy. Kumintang Ibaba, Batangas City',
    fatherName: 'Ernesto Villanueva',
    motherName: 'Deceased',
    siblings: 3,
    birthOrder: 4,
    medicalConditions: 'None',
    medications: 'None',
    riskScore: 55,
    riskLevel: 'moderate',
    status: 'active',
    assignedWorker: 'Maria Santos',
    photo: 'https://readdy.ai/api/search-image?query=young%20Filipino%20boy%206%20years%20old%20casual%20clothes%20portrait%20simple%20white%20background%20professional%20photo&width=200&height=200&seq=ch3&orientation=squarish',
    createdAt: '2026-02-20',
    incidentType: 'Child Labor',
    incidentDate: '2026-02-18',
    incidentDescription: 'Child observed selling sampaguita garlands along the highway during school hours. Father admitted child helps with livelihood due to poverty.',
    documents: [
      { name: 'Barangay Certification', type: '  PDF', date: '2026-02-20', size: '98 KB' },
      { name: 'Home Visit Report', type: 'PDF', date: '2026-02-22', size: '175 KB' },
    ],
    timeline: [
      { date: '2026-04-05', action: 'Livelihood assistance coordinated', user: 'Maria Santos', notes: 'Father enrolled in DSWD livelihood program.' },
      { date: '2026-03-10', action: 'School enrollment facilitated', user: 'Maria Santos', notes: 'Child enrolled in Kinder at Kumintang Ibaba Elementary.' },
      { date: '2026-02-20', action: 'Case opened', user: 'Maria Santos', notes: 'Initial intake completed. Supervisor approved.' },
    ],
    referrals: [
      { agency: 'DSWD Sustainable Livelihood Program', date: '2026-03-01', purpose: 'Livelihood assistance for guardian', status: 'Ongoing' },
    ],
    interAgencyNotes: [
      { agency: 'DepEd Batangas City', note: 'Child enrolled. School will provide school supplies and feeding.', date: '2026-03-12', officer: 'Teacher Dela Rosa' },
    ],
  },
  {
    id: 'ch4',
    caseNumber: 'DCPCMS-2026-00004',
    firstName: 'Sofia',
    lastName: 'Mendoza',
    middleName: 'Lim',
    nickname: 'Sofi',
    birthDate: '2011-09-05',
    age: 15,
    gender: 'Female',
    civilStatus: 'Single',
    nationality: 'Filipino',
    religion: 'Roman Catholic',
    address: '12 Aguinaldo St.',
    barangay: 'Brgy. Alangilan',
    municipality: 'Batangas City',
    province: 'Batangas',
    schoolName: 'Batangas City National High School',
    gradeLevel: 'Grade 9',
    guardianName: 'Perla Mendoza',
    guardianRelationship: 'Mother',
    guardianContact: '09461234567',
    guardianAddress: '12 Aguinaldo St., Brgy. Alangilan, Batangas City',
    fatherName: 'Absent',
    motherName: 'Perla Lim Mendoza',
    siblings: 1,
    birthOrder: 1,
    medicalConditions: 'Anxiety disorder',
    medications: 'Prescribed by psychiatrist',
    riskScore: 78,
    riskLevel: 'high',
    status: 'referred',
    assignedWorker: 'Maria Santos',
    photo: 'https://readdy.ai/api/search-image?query=young%20Filipino%20girl%2015%20years%20old%20school%20uniform%20portrait%20simple%20white%20background%20professional%20photo&width=200&height=200&seq=ch4&orientation=squarish',
    createdAt: '2026-03-01',
    incidentType: 'Sexual Abuse',
    incidentDate: '2026-02-28',
    incidentDescription: 'Child disclosed abuse to school guidance counselor. Immediate referral to DSWD and PNP WCPD made.',
    documents: [
      { name: 'Medico-Legal Report', type: 'PDF', date: '2026-03-02', size: '320 KB' },
      { name: 'Psychological Evaluation', type: 'PDF', date: '2026-03-10', size: '280 KB' },
      { name: 'Sworn Statement', type: 'PDF', date: '2026-03-03', size: '150 KB' },
    ],
    timeline: [
      { date: '2026-04-06', action: 'Referred to PNP WCPD', user: 'Maria Santos', notes: 'Case formally referred for criminal investigation.' },
      { date: '2026-03-15', action: 'Psychological counseling started', user: 'Maria Santos', notes: 'Child undergoing weekly therapy sessions.' },
      { date: '2026-03-05', action: 'Case conference with PNP and DOJ', user: 'Jose Reyes', notes: 'Multi-agency response plan formulated.' },
      { date: '2026-03-01', action: 'Case opened', user: 'Maria Santos', notes: 'Emergency intake completed.' },
    ],
    referrals: [
      { agency: 'PNP Women & Children Protection Desk', date: '2026-04-06', purpose: 'Criminal investigation', status: 'Ongoing' },
      { agency: 'DOJ Public Attorney\'s Office', date: '2026-03-05', purpose: 'Legal representation', status: 'Ongoing' },
      { agency: 'Batangas City Mental Health Center', date: '2026-03-10', purpose: 'Psychological counseling', status: 'Ongoing' },
    ],
    interAgencyNotes: [
      { agency: 'PNP WCPD', note: 'Suspect identified and warrant of arrest issued.', date: '2026-03-20', officer: 'SPO2 Bautista' },
      { agency: 'DOJ PAO', note: 'Case accepted. Lawyer assigned.', date: '2026-03-08', officer: 'Atty. Reyes' },
    ],
  },
  {
    id: 'ch5',
    caseNumber: 'DCPCMS-2026-00005',
    firstName: 'Carlo',
    lastName: 'Bautista',
    middleName: 'Navarro',
    nickname: 'Caloy',
    birthDate: '2016-11-30',
    age: 10,
    gender: 'Male',
    civilStatus: 'Single',
    nationality: 'Filipino',
    religion: 'Roman Catholic',
    address: '56 Luna St.',
    barangay: 'Brgy. Sta. Rita Karsada',
    municipality: 'Batangas City',
    province: 'Batangas',
    schoolName: 'Sta. Rita Elementary School',
    gradeLevel: 'Grade 4',
    guardianName: 'Nora Bautista',
    guardianRelationship: 'Mother',
    guardianContact: '09571234567',
    guardianAddress: '56 Luna St., Brgy. Sta. Rita Karsada, Batangas City',
    fatherName: 'Rodrigo Bautista',
    motherName: 'Nora Navarro Bautista',
    siblings: 2,
    birthOrder: 2,
    medicalConditions: 'None',
    medications: 'None',
    riskScore: 28,
    riskLevel: 'low',
    status: 'closed',
    assignedWorker: 'Maria Santos',
    photo: 'https://readdy.ai/api/search-image?query=young%20Filipino%20boy%2010%20years%20old%20school%20uniform%20portrait%20simple%20white%20background%20professional%20photo&width=200&height=200&seq=ch5&orientation=squarish',
    createdAt: '2025-11-10',
    incidentType: 'Emotional Abuse',
    incidentDate: '2025-11-08',
    incidentDescription: 'Child exhibited signs of emotional distress at school. Teacher reported child being verbally abused at home.',
    documents: [
      { name: 'Case Closure Report', type: 'PDF', date: '2026-03-15', size: '210 KB' },
      { name: 'Family Assessment', type: 'PDF', date: '2025-11-15', size: '190 KB' },
    ],
    timeline: [
      { date: '2026-03-15', action: 'Case closed', user: 'Maria Santos', notes: 'Family situation improved. Parents completed counseling.' },
      { date: '2026-01-20', action: 'Family counseling completed', user: 'Maria Santos', notes: 'Parents completed 8-session counseling program.' },
      { date: '2025-12-10', action: 'Family counseling started', user: 'Maria Santos', notes: 'Parents enrolled in parenting skills program.' },
      { date: '2025-11-10', action: 'Case opened', user: 'Maria Santos', notes: 'Initial intake completed.' },
    ],
    referrals: [],
    interAgencyNotes: [],
  },
  {
    id: 'ch6',
    caseNumber: 'DCPCMS-2026-00006',
    firstName: 'Liza',
    lastName: 'Fernandez',
    middleName: 'Ocampo',
    nickname: 'Lizzie',
    birthDate: '2019-01-25',
    age: 7,
    gender: 'Female',
    civilStatus: 'Single',
    nationality: 'Filipino',
    religion: 'Roman Catholic',
    address: '89 Quezon Ave.',
    barangay: 'Brgy. Cuta',
    municipality: 'Batangas City',
    province: 'Batangas',
    schoolName: 'Cuta Elementary School',
    gradeLevel: 'Grade 1',
    guardianName: 'Mila Fernandez',
    guardianRelationship: 'Grandmother',
    guardianContact: '09681234567',
    guardianAddress: '89 Quezon Ave., Brgy. Cuta, Batangas City',
    fatherName: 'Unknown',
    motherName: 'Absent (OFW)',
    siblings: 0,
    birthOrder: 1,
    medicalConditions: 'Fracture (healing)',
    medications: 'Pain reliever as needed',
    riskScore: 91,
    riskLevel: 'critical',
    status: 'active',
    assignedWorker: 'Maria Santos',
    photo: 'https://readdy.ai/api/search-image?query=young%20Filipino%20girl%207%20years%20old%20casual%20clothes%20portrait%20simple%20white%20background%20professional%20photo&width=200&height=200&seq=ch6&orientation=squarish',
    createdAt: '2026-03-28',
    incidentType: 'Physical Abuse',
    incidentDate: '2026-03-27',
    incidentDescription: 'Child brought to hospital with fractured arm. Hospital staff reported suspected child abuse. Grandmother claims child fell.',
    documents: [
      { name: 'Hospital Report', type: 'PDF', date: '2026-03-28', size: '290 KB' },
      { name: 'X-Ray Results', type: 'PDF', date: '2026-03-28', size: '1.5 MB' },
    ],
    timeline: [
      { date: '2026-04-09', action: 'Emergency home visit', user: 'Maria Santos', notes: 'Child temporarily placed with relative pending investigation.' },
      { date: '2026-03-30', action: 'Medical follow-up', user: 'Maria Santos', notes: 'Child recovering. Fracture healing well.' },
      { date: '2026-03-28', action: 'Case opened', user: 'Maria Santos', notes: 'Emergency intake. Supervisor notified.' },
    ],
    referrals: [
      { agency: 'PNP Women & Children Protection Desk', date: '2026-03-29', purpose: 'Investigation of suspected abuse', status: 'Ongoing' },
    ],
    interAgencyNotes: [
      { agency: 'Batangas City Health Office', note: 'Child under medical monitoring. Follow-up in 2 weeks.', date: '2026-03-30', officer: 'Dr. Santos' },
    ],
  },
  {
    id: 'ch7',
    caseNumber: 'DCPCMS-2026-00007',
    firstName: 'Miguel',
    lastName: 'Torres',
    middleName: 'Castillo',
    nickname: 'Miggy',
    birthDate: '2012-06-14',
    age: 14,
    gender: 'Male',
    civilStatus: 'Single',
    nationality: 'Filipino',
    religion: 'Roman Catholic',
    address: '34 Mabini St.',
    barangay: 'Brgy. Pallocan West',
    municipality: 'Batangas City',
    province: 'Batangas',
    schoolName: 'Pallocan West National High School',
    gradeLevel: 'Grade 8',
    guardianName: 'Lito Torres',
    guardianRelationship: 'Father',
    guardianContact: '09791234567',
    guardianAddress: '34 Mabini St., Brgy. Pallocan West, Batangas City',
    fatherName: 'Lito Torres',
    motherName: 'Absent',
    siblings: 4,
    birthOrder: 1,
    medicalConditions: 'None',
    medications: 'None',
    riskScore: 48,
    riskLevel: 'moderate',
    status: 'active',
    assignedWorker: 'Maria Santos',
    photo: 'https://readdy.ai/api/search-image?query=young%20Filipino%20boy%2014%20years%20old%20school%20uniform%20portrait%20simple%20white%20background%20professional%20photo&width=200&height=200&seq=ch7&orientation=squarish',
    createdAt: '2026-04-01',
    incidentType: 'Neglect',
    incidentDate: '2026-03-30',
    incidentDescription: 'Child frequently absent from school. Father works night shift and leaves children unsupervised. Eldest child responsible for younger siblings.',
    documents: [
      { name: 'School Attendance Record', type: 'PDF', date: '2026-04-01', size: '145 KB' },
    ],
    timeline: [
      { date: '2026-04-08', action: 'Home visit conducted', user: 'Maria Santos', notes: 'Met with father. Discussed importance of supervision.' },
      { date: '2026-04-01', action: 'Case opened', user: 'Maria Santos', notes: 'Initial intake completed.' },
    ],
    referrals: [],
    interAgencyNotes: [],
  },
];
